/* istanbul ignore file */
import React from "react";

export const UnstableFeaturesStatusContext = React.createContext(null);

export const ifUnstableFeatureEnabled = ({
  featureName,
  Enabled,
  Disabled,
}) => props => {
  return (
    <UnstableFeaturesStatusContext.Consumer>
      {unstableFeaturesStatus => {
        let status = unstableFeaturesStatus.unstableFeatures[featureName];
        if (status !== false && status !== true) {
          throw new Error(
            `Unstable Feature Status for ${featureName} should either be true or false`,
          );
        }
        const Component = status ? Enabled : Disabled;
        if (Component === null) {
          return null;
        } else {
          return <Component {...props} />;
        }
      }}
    </UnstableFeaturesStatusContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/sc/ui/components/hoc/ifUnstableFeatureEnabled.js